import {
  FormField,
  Input,
  Popover,
  TextContent,
  Textarea,
} from '@amzn/awsui-components-react';
import { ReactElement, useEffect, useState } from 'react';
import { FieldProps } from '../FieldProps';

export const ShortDescriptionField = (
  props: FieldProps<string, true>
): ReactElement => {
  const [valid, setValid] = useState(true);
  useEffect(() => {
    const isValid: boolean =
      (!props.required && !props.value) ||
      props.disabled ||
      (Boolean(props.value) && /^.{1,120}$/.test(props.value));
    setValid(isValid);
  }, [props.value, props.required, props.disabled]);
  useEffect(() => props.onValidate?.(valid), [valid]);
  return (
    <FormField
      label='Short description'
      stretch
      errorText={!valid ? 'Should be under 120 chars' : undefined}
      description={
        <Popover
          triggerType='custom'
          position='right'
          size='small'
          content={
            <TextContent>
              <p>
                <b>Example: </b>
                <code>
                  Run &lt;noloc&gt;Kubernetes&lt;/noloc&gt; on &lt;shared
                  id=&quot;AWS&quot;/&gt; without operating your own
                  &lt;noloc&gt;Kubernetes&lt;/noloc&gt; clusters
                </code>
              </p>
            </TextContent>
          }
        >
          Click for example usage
        </Popover>
      }
    >
      <Textarea
        disabled={props.disabled}
        value={props.value}
        invalid={!valid}
        onChange={({ detail: { value } }) => {
          props.onChange?.(value);
        }}
      />
      {typeof props.old === 'string' && props.old !== props.value && (
        <Input disabled={true} value={props.old} />
      )}
    </FormField>
  );
};
